<template lang="pug">
.dataset-menu
  menu-item(:label=`$t('image')`, v-model="frameStore.showSurface")
  menu-item(:label=`$t('frame')`, v-model="frameStore.showFrame")
  menu-separator
  template(v-for="(release, i) in Env.releases")
    menu-item(v-for="rerun in release.reruns", :label="rerun", :key="rerun", v-model="frameStore.activeReruns", :value="rerun", :keybind="keybind(rerun)")
    menu-separator(v-if="i < Env.releases.length - 1")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { SspDataModule } from "@/modules/SspDataModule";
import { FrameStore } from "@/modules/base";
import { env } from '@/env';

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: SspDataModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof SspDataModule>

  keybind(rerun: string) {
    const reruns: string[] = []
    for (const r of env.releases) {
      reruns.push(...r.reruns)
    }
    const i = reruns.indexOf(rerun)
    return i < 9 ? `shift+${i + 1}` : ''
  }
}
</script>

<i18n>
en:
  image: Image
  frame: Frame
ja:
  image: 画像
  frame: 領域枠

</i18n>